import logSicoop from '../../assets/logo-sicoop-comercios.png';

export function LogoSicoop({tamano}){
    return (
      <img
        src={logSicoop}
        alt="logosicoop"
        // width={`${tamano}px`}
        // height={`${tamano - 50}px`}
        style={{ 
          maxWidth: `${tamano}px`,
          maxHeight: `${tamano - 50}px`,
          width: 'auto',
         }}
      />
    );
  }